module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-greek-ext14.18af251.woff2";